// Shared CDN path for the Use 3D tooltip clip. Mirrors the board-tour layout
// under cdn.rundiffusion.com/file/rd-web-assets/image-ai/feature-tours/.
export const USE_3D_TOOLTIP_VIDEO_URL = 'https://cdn.rundiffusion.com/file/rd-web-assets/image-ai/feature-tours/use-3d/use_3d.mp4';
